import { templateContentsId, type TemplateContentsId } from "./TemplateContents";
import { localeEnum, type default as LocaleEnum } from "./LocaleEnum";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for template_cont_locale */
export type TemplateContLocaleId = string & { __flavor: "TemplateContLocaleId" };

/**
 * Represents the table public.template_cont_locale
 * @uniqueConstraints {"template_cont_locale_pkey":{"name":"template_cont_locale_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"unique_template_content_locale":{"name":"unique_template_content_locale","isPrimary":false,"isUnique":true,"columns":[{"name":"template_content_id","definition":"template_content_id","predicate":null},{"name":"locale","definition":"locale","predicate":null}]}}
 */
export default interface TemplateContLocaleTable {
  id: ColumnType<TemplateContLocaleId, TemplateContLocaleId | undefined, TemplateContLocaleId>;

  templateContentId: ColumnType<TemplateContentsId, TemplateContentsId, TemplateContentsId>;

  locale: ColumnType<LocaleEnum, LocaleEnum, LocaleEnum>;

  content: ColumnType<unknown | null, unknown | null, unknown | null>;

  metadata: ColumnType<unknown | null, unknown | null, unknown | null>;

  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;
}

export type TemplateContLocale = Selectable<TemplateContLocaleTable>;

export type NewTemplateContLocale = Insertable<TemplateContLocaleTable>;

export type TemplateContLocaleUpdate = Updateable<TemplateContLocaleTable>;

export const templateContLocaleId = z.string() as unknown as z.Schema<TemplateContLocaleId>;

export const templateContLocale = z.object({
  id: templateContLocaleId,
  templateContentId: templateContentsId,
  locale: localeEnum,
  content: z.unknown().nullable(),
  metadata: z.unknown().nullable(),
  createdAt: z.date(),
});

export const templateContLocaleInitializer = z.object({
  id: templateContLocaleId.optional(),
  templateContentId: templateContentsId,
  locale: localeEnum,
  content: z.unknown().optional().nullable(),
  metadata: z.unknown().optional().nullable(),
  createdAt: z.date().optional(),
});

export const templateContLocaleMutator = z.object({
  id: templateContLocaleId.optional(),
  templateContentId: templateContentsId.optional(),
  locale: localeEnum.optional(),
  content: z.unknown().optional().nullable(),
  metadata: z.unknown().optional().nullable(),
  createdAt: z.date().optional(),
});

// ── constraints for TemplateContLocale ─────────────────────────────────
export const TemplateContLocaleConstraints = {
  template_cont_locale_pkey: {
    name: "template_cont_locale_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  unique_template_content_locale: {
    name: "unique_template_content_locale",
    isPrimary: false,
    isUnique: true,
    columns: [
      { name: "template_content_id", definition: "template_content_id", predicate: null },
      { name: "locale", definition: "locale", predicate: null },
    ],
  },
} as const;
export type TemplateContLocaleConstraintsType = typeof TemplateContLocaleConstraints;
